import React from 'react';
import { Dialog } from '@headlessui/react';
import { deleteZone } from 'UpdatedFeatures/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

const DeleteZoneModal = ({ open, setOpen, zone, onDelete }) => {
  const queryClient = useQueryClient();

  const deleteMutation = useMutation({
    mutationFn: deleteZone,
    onSuccess: () => {
      queryClient.invalidateQueries(['zones']);
      setOpen(false);
      toast.success("Zone supprimé avec succès");
    },
    onError: (error) => {
      toast.error(error.message || "Erreur lors de la Zone");
    }
  });

  const handleDelete = () => {
    console.log('Suppression de la zone :', zone.id);
    deleteMutation.mutate(zone.id);
  };

  return (
    <Dialog open={open} onClose={() => setOpen(false)} style={{ zIndex: 9990 }} className="relative z-50">
      <div className="fixed inset-0 bg-black/40" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="w-full max-w-md rounded-lg bg-white p-6">
          <Dialog.Title className="text-lg font-medium text-gray-900">
            Supprimer la zone
          </Dialog.Title>
          <div className="mt-4">
            <p className="text-sm text-gray-500">
              Êtes-vous sûr de vouloir supprimer la zone {zone?.name} ? 
            </p>
          </div>
          <div className="mt-6 flex justify-end space-x-3">
            <button
              type="button"
              onClick={() => setOpen(false)}
              className="inline-flex justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50"
            >
              Annuler
            </button>
            <button
              type="button"
              onClick={handleDelete}
              className="inline-flex justify-center rounded-md border border-transparent bg-red-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-red-700"
            >
              {deleteMutation.isPending ? "Loading" : "Supprimer"}
            </button>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};

export default DeleteZoneModal;
